import {
  QUERY_STRING_INSTALL_PAGE_URL,
  QUERY_STRING_INSTALL_TYPE,
  QUERY_STRING_LAYOUT,
} from "../../constants";
import { getOptions } from "../../options/options";
import { RewardDisplayEnum } from "../types/runtimeTypes";
import { DatabaseId, Locale, VerificationStep } from "../types/types";
import { logger } from "../utils/logger/logger";

export const getVerificationUrl = () =>
  `${getOptions().restApi.serviceUrl}${getOptions().restApi.resources.verification}`;
export const getVerificationStatusUrl = (verificationId: DatabaseId) =>
  `${getVerificationUrl()}${verificationId}`;
export const getNewVerificationRequestUrl = () => getVerificationUrl();
export const getProgramThemeUrl = (programId: DatabaseId, locale: Locale = null) => {
  const baseUrl = `${getOptions().restApi.serviceUrl}${
    getOptions().restApi.resources.program.base
  }${programId}/${getOptions().restApi.resources.program.theme}`;
  if (locale) {
    return `${baseUrl}?locale=${locale}`;
  }
  return `${baseUrl}`;
};

export const getNewSmsCodeResendUrl = (verificationId: DatabaseId) =>
  `${getOptions().restApi.serviceUrl}rest/v2/verification/${verificationId}/step/smsLoop/retry`;
export const getNewEmailCodeResendUrl = (verificationId: DatabaseId) =>
  `${getOptions().restApi.serviceUrl}rest/v2/verification/${verificationId}/step/emailLoop/retry`;

export const getFieldsToCollectUrl = (verificationId: DatabaseId, stepName: VerificationStep) =>
  `${getOptions().restApi.serviceUrl}rest/v2/verification/${verificationId}/${stepName}/fields`;

export const getDocTypeForCountriesUrl = (verificationId: DatabaseId, countries: string[]) =>
  `${
    getOptions().restApi.serviceUrl
  }rest/v2/verification/${verificationId}/step/idCheckLoop/getDocumentTypesForCountries?countries=${countries}`;

export const getBarcodeUrl = (
  verificationId: DatabaseId,
  rewardKey: string,
  symbology: RewardDisplayEnum,
) =>
  `${
    getOptions().restApi.serviceUrl
  }rest/v2/verification/${verificationId}/barcode?rewardKey=${rewardKey}&symbology=${symbology}`;

/**
 * Get the version that was actually used
 * The build process replaces this with the value.
 * e.g. 1.59.0 or 1.46.0-alpha.575
 */
export const getPublishedVersion = (): string => process.env.NEXT_VERSION;

export const getCurrentUrl = (): string => window.location.href;

export const getInstallPageUrl = (): string | undefined => {
  try {
    const parsed: URLSearchParams = new URLSearchParams(window.location.search);

    if (parsed.get(QUERY_STRING_INSTALL_PAGE_URL)) {
      return decodeURIComponent(parsed.get(QUERY_STRING_INSTALL_PAGE_URL));
    }
    if (getOptions()[QUERY_STRING_INSTALL_PAGE_URL]) {
      return getOptions()[QUERY_STRING_INSTALL_PAGE_URL];
    }
  } catch (e) {
    logger.error(e, "Install Page URL");
  }

  return getCurrentUrl();
};

export const InstallTypes = {
  landingPage: "landing_page",
  cdnNoIframe: "cdn_no_iframe",
  cdnInlineIframe: "cdn_inline_iframe",
  cdnModalIframe: "cdn_modal_iframe",
} as const;
export type InstallType = (typeof InstallTypes)[keyof typeof InstallTypes];

const QUERY_VALUE_LANDING = "landing";

export const getInstallType = (): InstallType | string => {
  try {
    const parsed: URLSearchParams = new URLSearchParams(window.location.search);

    if (parsed.get(QUERY_STRING_INSTALL_TYPE)) {
      return decodeURIComponent(parsed.get(QUERY_STRING_INSTALL_TYPE));
    }

    if (parsed.get(QUERY_STRING_LAYOUT) === QUERY_VALUE_LANDING) {
      return InstallTypes.landingPage;
    }
  } catch (e) {
    logger.error(e, "getInstallType");
  }

  return window.sheerIdInstallType || InstallTypes.cdnNoIframe;
};

export const getVerificationHelpUrl = (): string =>
  `${getOptions().restApi.serviceUrl}rest/v2/help/verificationHelp`;
